/* eslint-disable */
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {
  getAuth,
  sendPasswordResetEmail,
  confirmPasswordReset,
} from "firebase/auth";
import Image from "react-bootstrap/Image";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n"
import DarkModeToggle from "../../components/navbar/DarkModeToggle";

function Recover() {
  const auth = getAuth();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const oobCode = queryParams.get("oobCode");
  const navigate = useNavigate(); // استخدام useNavigate للتنقل بين الصفحات
  const { t, i18n } = useTranslation();
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const isRTL = i18n.dir() === "rtl";
  const [loginSign, setLoginSign] = useState(true);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState(false);

  const handleEmailSubmit = (e) => {
  setError(false);
  e.preventDefault();
  sendPasswordResetEmail(auth, loginForm.email)
    .then(() => {
      // احذف هذا السطر:
      // localStorage.setItem("resetPasswordTimestamp", Date.now());

      setLoginForm({ ...loginForm, email: "" });
      setMessage(
        t("ui.resetLinkSent")
      );
    })
    .catch((error) => {
      setError(true);
    });
};
  const handlePasswordReset = (e) => {
  setError(false);
  e.preventDefault();

  // التحقق من تطابق كلمات المرور فقط
  if (loginForm.password !== loginForm.confirmPassword) {
    setError(t("ui.passwordMismatch"));
    return;
  }

  confirmPasswordReset(auth, oobCode, loginForm.password)
    .then(() => {
      setMessage(t("ui.passwordChanged"));
      setTimeout(() => {
        navigate("/login");
      }, 2000);
    })
    .catch((error) => {
      // Firebase سيعطيك رسالة الخطأ الصحيحة
      if (error.code === 'auth/expired-action-code') {
        setError(t("ui.resetLinkExpired"));
      } else if (error.code === 'auth/invalid-action-code') {
        setError(t("ui.resetLinkInvalid"));
      } else {
        setError(t("ui.tryAgainError"));
      }
    });
};

  return (
    <main className="w-full flex dark:bg-[#141414] dark:text-gray-200" dir={i18n.dir()}>
      <div className="relative flex-1 hidden items-center justify-center h-screen bg-gray-900 overflow-hidden lg:flex">
        <div className="relative z-10 w-full max-w-md">
          <img src="/logowhite.png" width={150} alt={t("ui.logo")} />
          <div className="mt-16 space-y-3">
            <h3 className="text-white text-3xl font-bold">
              {t("resetPassword.left.title")}
            </h3>
            <p className="text-gray-300">
              {t("resetPassword.left.description")}
            </p>
            <div className="flex items-center gap-3 -space-x-2 overflow-hidden">
              <div className="flex items-center -space-x-2 overflow-hidden">
                <img
                  src="https://randomuser.me/api/portraits/women/79.jpg"
                  className="rounded-lg overflow-hidden shadow-sm w-10 h-10 bg-[#faf1ff] border-2 border-white"
                  alt="User 1"
                />
                <img
                  src="https://api.uifaces.co/our-content/donated/xZ4wg2Xj.jpg"
                  className="rounded-lg overflow-hidden shadow-sm w-10 h-10 bg-[#faf1ff] border-2 border-white"
                  alt="User 2"
                />
                <img
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=a72ca28288878f8404a795f39642a46f"
                  className="rounded-lg overflow-hidden shadow-sm w-10 h-10 bg-[#faf1ff] border-2 border-white"
                  alt="User 3"
                />
                <img
                  src="https://randomuser.me/api/portraits/men/86.jpg"
                  className="rounded-lg overflow-hidden shadow-sm w-10 h-10 bg-[#faf1ff] border-2 border-white"
                  alt="User 4"
                />
                <img
                  src="https://images.unsplash.com/photo-1510227272981-87123e259b17?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=3759e09a5b9fbe53088b23c615b6312e"
                  className="rounded-lg overflow-hidden shadow-sm w-10 h-10 bg-[#faf1ff] border-2 border-white"
                  alt="User 5"
                />
              </div>

              <p
                dir={i18n.dir()}
                className={`text-sm text-gray-400 font-medium ${i18n.dir() === "rtl" ? "mr-[-10px] text-right" : "ml-[-10px] text-left"}`}
              >
                {"  "} {t("resetPassword.left.joined")}
              </p>
            </div>
          </div>
        </div>
        <div
          className="absolute inset-0 my-auto h-[500px]"
          style={{
            background:
              "linear-gradient(152.92deg, rgba(192, 132, 252, 0.2) 4.54%, rgba(232, 121, 249, 0.26) 34.2%, rgba(192, 132, 252, 0.1) 77.55%)",
            filter: "blur(118px)",
          }}
        ></div>
      </div>
      <div className="flex-1 flex items-center justify-center h-screen relative">

        <div className="absolute top-4 w-full px-4 flex justify-between z-50">
          {/* Select langue */}
          <div className={`${isRTL ? "order-2" : "order-1"}`}>
            <select
              onChange={(e) => i18n.changeLanguage(e.target.value)}
              className="px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-600 dark:bg-[#1b1b1b] dark:!border-[#3c3a3d] dark:text-gray-200"
              value={i18n.language}
            >
              <option value="ar">{t("login.language.ar")}</option>
              <option value="fr">{t("login.language.fr")}</option>
              <option value="en">{t("login.language.en")}</option>
            </select>
          </div>

          {/* Toggle dark mode */}
          <div className={`${isRTL ? "order-1" : "order-2"}`}>
            <DarkModeToggle />
          </div>
        </div>

        <div className="max-w-sm w-full text-gray-600 dark:text-gray-300 space-y-5">
          <div className="text-center pb-8">
            <img src="/Logo.png" width={150} className="mx-auto" alt={t("ui.logo")} />
            <div className="mt-5">
              <h3 className="text-gray-800 dark:text-gray-100 text-2xl font-bold sm:text-3xl">
                {oobCode ? t("resetPassword.title.reset") : t("resetPassword.title.forgot")}
              </h3>
            </div>
          </div>
          <form
            onSubmit={oobCode ? handlePasswordReset : handleEmailSubmit}
            className="space-y-5"
          >
            {!oobCode ? (
              <div>
                <label className="font-medium dark:text-gray-200" controlId="formBasicEmail">
                  {t("resetPassword.email.label")}
                </label>
                <input
                  value={loginForm.email}
                  onChange={(e) => {
                    setLoginForm({ ...loginForm, email: e.target.value });
                  }}
                  type="email"
                  required
                  className="w-full mt-2 px-3 py-2 text-gray-500 dark:text-gray-200 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg dark:!border-[#3c3a3d] dark:placeholder-gray-500"
                />
              </div>
            ) : (
              <>
                <div>
                  <label className="font-medium dark:text-gray-200" controlId="formBasicPassword">
                    {t("resetPassword.newPassword.label")}
                  </label>
                  <input
                    value={loginForm.password}
                    onChange={(e) => {
                      setLoginForm({ ...loginForm, password: e.target.value });
                    }}
                    type="password"
                    required
                    className="w-full mt-2 px-3 py-2 text-gray-500 dark:text-gray-200 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg dark:!border-[#3c3a3d] dark:placeholder-gray-500"
                  />
                </div>
                <div>
                  <label
                    className="font-medium dark:text-gray-200"
                    controlId="formBasicConfirmPassword"
                  >
                    {t("resetPassword.confirmPassword.label")}
                  </label>
                  <input
                    value={loginForm.confirmPassword}
                    onChange={(e) => {
                      setLoginForm({
                        ...loginForm,
                        confirmPassword: e.target.value,
                      });
                    }}
                    type="password"
                    required
                    className="w-full mt-2 px-3 py-2 text-gray-500 dark:text-gray-200 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg dark:!border-[#3c3a3d] dark:placeholder-gray-500"
                  />
                </div>
              </>
            )}
            {message && <p className="text-success dark:text-green-400">{message}</p>}
            {error && <p className="text-danger dark:text-red-400">{t("resetPassword.error")} {error}</p>}

            <button
              className="w-full px-4 py-2 text-white font-medium bg-[#9b59bf] hover:bg-indigo-500 active:bg-[#9b59bf] rounded-lg duration-150"
              type="submit"
            >
              {oobCode
                ? t("resetPassword.button.reset")
                : t("resetPassword.confirmPassword.label")}
            </button>
          </form>
          {!oobCode && (
            <p className="text-center dark:text-gray-300">
              {t("resetPassword.noAccount")}{" "}
              <Link
                to={`/sign-up`}
                className="font-medium text-[#9e68ba] hover:text-[#55266d]"
              >
                {t("resetPassword.signup")}
              </Link>
            </p>
          )}
        </div>
      </div>
    </main>
  );
}

export default Recover;
